<template>
	<div>
		<div class="providerRegister">
			<div class="banner">
				<img src="static/img/provider-bg.png">
			</div>
			<h3>加入我们</h3>
			<div class="content">
				<div class="input">
					<span>手机号</span>
					<input type="text" v-model="form.phone" placeholder="请输入手机号码" />
				</div>
				<div class="input">
					<span>密码</span>
					<input type="password" v-model="form.password" autocomplete='new-password' placeholder="请输入密码" />
				</div>
				<button class="btn-blue" v-show="providerCode" @click="providerRegister">立即加入</button>
				<p class="tologin"><a :href="'/reginalAgent/providerLogin?providerCode='+providerCode">已有账号？去登录</a></p>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
import axios from 'axios'
	export default {
		name: 'providerRegister',
		data() {
			return {
				tjk_login_token: null, //注册成功后返回token
				form: {
					phone: '',
					password: ''
				},
				providerCode: this.$route.query.providerCode //'D85688FCE613669775C5EEF50F20386A'
			}
		},
		mounted() {
			if(this.providerCode) {
				this.checkCode()
			}
		},
		methods: {
			//判断合作公司推荐注册二维码
			checkCode() {
				var data = {
					'providerCode': this.providerCode?this.providerCode: ''
				}
				this.$http.post(API_ROOT.provider + '/agent/checkCode', data).then(response=> {
					var result = response.data
					if(result.success) {
					}else {
						this.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 2000
						})
					}
				},response=> {
					this.$message({
						showClose: true,
						message: '网络繁忙，请稍后重试！',
						type: 'error',
						center: true,
						duration: 2000
					})
				})
			},
			//合作公司推荐人注册
			providerRegister() {
				var self = this
				if(this.form.phone == '') {
					this.$message({
						message: '请填写手机号码',
						type: 'error',
						center: true,
						duration: 3000
					})
					return
				}
				if(this.form.phone.length != 11) {
					this.$message({
						message: '手机格式有误，请重新输入！',
						type: 'error',
						center: true,
						duration: 3000
					})
					return
				}
				if(this.form.password == '') {
					this.$message({
						message: '请输入密码',
						type: 'error',
						center: true,
						duration: 3000
					})
					return
				}
				var data = {
					phone: this.form.phone,
					password: this.form.password,
					providerCode: this.providerCode
				}
				this.$http.post(API_ROOT.tjuser + '/provider/providerRegister', data).then(response=> {
					var result = response.data
					if(result.success) {
						this.tjk_login_token = result.data
						window.location.href = '/reginalAgent/providerHasLogin?token='+this.tjk_login_token+'&phone='+this.form.phone+'&providerCode='+this.providerCode
					}else {
						this.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 3000
						})
					}
				},response=> {
					this.$message({
						message: '网络繁忙，请稍后重试！',
						type: 'error',
						center: true,
						duration: 3000
					})
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// providerRegister.vue?5b140998